import api from '~/helpers/api';

export default class ExchangeRatesService {
    static fetchExchangeRates(curList: string[]): Promise<any> {
        const params = new URLSearchParams({ curList: curList.join(',') });

        return api.get(`server-middleware/getExchangeRates?${ params }`);
    }
}
